import { openFolder } from "@/components/misc";


export function TitleHeaderHyperlink({ title, folder_location }: { title: string; folder_location: string; }) {
    return (
        <h5 className="font-bold cursor-pointer underline text-blue-500 dark:text-blue-400 inline-block hover:text-blue-600 dark:hover:text-blue-300" onClick={() => openFolder(folder_location)}>{title}</h5>
    );
}
